const createAsyncAction =
  (apiFxn, actionTypes) => (payload) => async (dispatch) => {
    try {
      const response = await apiFxn(payload);
      const { error, data } = response;

      if (error) {
        dispatch({ type: actionTypes.failure, payload: error });
      } else {
        dispatch({ type: actionTypes.success, payload: data });
      }

      return response;
    } catch (error) {
      dispatch({ type: actionTypes.failure, payload: error.message });
      return { error: error.message };
    }
  };

export default createAsyncAction;
